import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, TransitionGroup as _TransitionGroup } from "vue"

const _hoisted_1 = { class: "invoice" }
const _hoisted_2 = { class: "invoice-content" }
const _hoisted_3 = { class: "invoice-function" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode("登記抽獎")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InvoiceBanner = _resolveComponent("InvoiceBanner")
  const _component_InvoiceRule = _resolveComponent("InvoiceRule")
  const _component_invoice_button = _resolveComponent("invoice-button")
  const _component_InvoicePopup = _resolveComponent("InvoicePopup")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode(_component_InvoiceBanner, {
        imgUrl: _ctx.result.banner_url
      }, null, 8, ["imgUrl"]),
      _createVNode(_component_InvoiceRule, {
        content: _ctx.result.event_wording
      }, null, 8, ["content"])
    ]),
    _createVNode("div", _hoisted_3, [
      _createVNode(_component_invoice_button, { onClick: _ctx.handler }, {
        default: _withCtx(() => [
          _hoisted_4
        ]),
        _: 1
      }, 8, ["onClick"])
    ]),
    _createVNode(_TransitionGroup, { name: "page" }, {
      default: _withCtx(() => [
        (_ctx.isPopupOpen)
          ? (_openBlock(), _createBlock(_component_InvoicePopup, {
              key: 0,
              modelValue: _ctx.popupData,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.popupData = $event)),
              onClose: _ctx.closePopup,
              onLogin: _ctx.handleLogin,
              onWallet: _ctx.handleWallet
            }, null, 8, ["modelValue", "onClose", "onLogin", "onWallet"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}